Namespace.create('cv.Views.Modals').UnsavedChangesView = Marionette.LayoutView.extend({
  id: 'modal-confirm',

  template: cv.Templates['global/modals/unsaved_changes/view'],

  events : {
    'click .modal-confirm' : 'confirm',
    'click .modal-deny' : 'deny'
  },

  validation: {},

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('UnsavedChangesView initialized');
  },

  templateHelpers: function(){
    return {
    };
  },

  confirm: function(e){
    e.preventDefault();

    _.each(cv.unsaved_views, function(view, key, list){
      view.on('form:saved', function(){
        cv.router.navigate(this.options.target, { trigger : true });
        vent.trigger('modal:hide');
      }, this);
      view.trigger('form:save');
    }, this);
  },

  deny: function(e){
    e.preventDefault();

    cv.unsaved_views = {};
    cv.router.navigate(this.options.target, { trigger : true });
    vent.trigger('modal:hide');
  }
});
